require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-schandorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-schandorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-schandorf!./.cache/json/betreuungseinrichtungen-oberwart-schandorf.json
// module id = 1025
// module chunks = 231608221292675